import { CountryBoundType, type Country, type FoundedCountry } from '@/shared/types/api.types'
import type { Locale } from '@/shared/types/common.types'
import HttpService from '../HttpService'
import countriesHash from './countries'
import type { CountryResponse } from './CountriesService.types'

const getPopularity = (
  boundType: CountryBoundType = CountryBoundType.OUTBUND,
  response: CountryResponse
): number => {
  let value
  if (boundType === CountryBoundType.OUTBUND) {
    value = response.popularOutbound
  } else {
    value = response.popularInbound
  }

  return value || 999
}

export class CountriesService extends HttpService {
  async getCountries(
    boundType: CountryBoundType = CountryBoundType.OUTBUND,
    locale?: string,
    name?: string
  ): Promise<Country[]> {
    const productCode = boundType === CountryBoundType.OUTBUND ? 'traveloutbound' : 'travelinbound'
    const response = await this.get<CountryResponse[]>('/listcountries', {
      params: {
        productCode,
        locale,
        name,
      },
    })

    return response
      .map((el) => {
        const popularity = getPopularity(boundType, el)

        return {
          id: el.countryCode,
          name: el.countryName,
          popular: String(popularity),
          isocode: countriesHash[el.countryCode] || el.iso.toLowerCase(),
          code: el.countryCode,
          searchString: el.searchWords,
        }
      })
      .sort((a, b) => Number(b.popular) - Number(a.popular))
  }

  findCountries(
    boundType: CountryBoundType = CountryBoundType.OUTBUND,
    locale?: Locale,
    name?: string
  ): Promise<FoundedCountry[]> {
    return this.getCountries(boundType, locale, name).then((res) => {
      return res.map((el) => ({
        code: el.code,
        desc: el.name,
        isocode: el.isocode,
      }))
    })
  }
}
